import { render, staticRenderFns } from "./q-ans-update-screen.html?vue&type=template&id=0e30b34b&scoped=true&external"
import script from "./q-ans-update-screen.js?vue&type=script&lang=js&external"
export * from "./q-ans-update-screen.js?vue&type=script&lang=js&external"
import style0 from "./q-ans-update-screen.scss?vue&type=style&index=0&id=0e30b34b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e30b34b",
  null
  
)

export default component.exports